import 'ui-core/plugins/scrollo/js/scrollo';

(function () {
    var scrollo = null;
    if (typeof UX.scrollo !== 'undefined') {
        scrollo = UX.scrollo;
        scrollo.get.fixedpageElementsHeight = function () {
            var elementsHeight = 0;
            var $fixedHeader = $('header.fixed');
            if ($fixedHeader.length) {
                elementsHeight = $fixedHeader.outerHeight();
            }

            $('.sticky-element').each(function () {
                if ($(this).outerHeight() > 0) {
                    elementsHeight += $(this).outerHeight();
                }
            });

            return elementsHeight;
        };
        UX.scrollo = scrollo;
    }
})();
